import cn from "classnames";
import Datetime from "components/shared/datetime";
import Select, { customFilterSelectStyles, defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { logistTaskTypes } from "helpers/enums";
import debounce from "lodash/debounce";
import React, { useCallback, useMemo, useState } from "react";
import { list as logistsList } from "sources/books/employees";
import { numbersList as trucksList } from "sources/books/trucks";
import { getListForSelect } from "sources/books/usersGroups";

export default function Filter(props) {
    const [filtersOpened, setFiltersOpened] = useState(false);
    const { setFilter, resetFilters, filters } = props;
    const [bidId, setBidId] = useState(filters.bidId || "");
    const onBidIdChange = useCallback(
        debounce((value) => setFilter({ name: "bidId", value: value || undefined }), 300),
        [],
    );

    const hasFilters = useMemo(() => Object.keys(filters).length > 0, [filters]);

    const resetAllFilters = () => {
        setBidId("");
        resetFilters();
    };

    const refreshData = (e) => {
        e.stopPropagation();
        props.refreshData();
    };

    const selectProps = {
        ...defaultMultipleSelectProps,
        styles: { ...customFilterSelectStyles },
        components: { ValueContainer },
    };

    const expandCname = cn("b-filter__collapse-btn", {
        "b-filter__collapse-btn--top": filtersOpened,
        "b-filter__collapse-btn--bottom": !filtersOpened,
    });
    const headerTextCname = cn("b-filter__search-text", { "b-filter__search-text--dark": filtersOpened });

    return (
        <div className="b-filter">
            <div className="b-filter__head" onClick={() => setFiltersOpened(!filtersOpened)}>
                <div className="b-filter__head--left">
                    {!filtersOpened && <div className="b-filter__filter-icon" />}
                    <div className={headerTextCname}>Фильтры</div>
                </div>
                <div className="b-filter__head--right">
                    {!filtersOpened && (
                        <>
                            {hasFilters && (
                                <div className="b-filter__btn b-filter__btn--reset" onClick={resetFilters}>
                                    Сбросить
                                </div>
                            )}
                            <div className="b-filter__btn b-filter__btn--refresh" onClick={refreshData}>
                                Обновить
                            </div>
                        </>
                    )}
                    <div className={expandCname} />
                </div>
            </div>
            {filtersOpened && (
                <>
                    <div className="b-filter__body">
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <input
                                    className="b-filter__input"
                                    placeholder="Номер заявки (ID, номер, номер в 1С)"
                                    value={bidId}
                                    name="bidId"
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setBidId(value);
                                        onBidIdChange(value);
                                    }}
                                />
                            </div>
                            <div className="pb-1">
                                <div className="d-flex">
                                    <Datetime
                                        libOptions={{
                                            className: "b-filter__input",
                                            placeholderText: "Срок, от",
                                            isClearable: true,
                                        }}
                                        value={filters.deadlineFrom}
                                        inputProps={{ name: "deadlineFrom", type: "date" }}
                                        onChange={setFilter}
                                    />
                                    <span className="px-1">&#8211;</span>
                                    <Datetime
                                        libOptions={{
                                            className: "b-filter__input",
                                            placeholderText: "Срок, до",
                                            isClearable: true,
                                        }}
                                        value={filters.deadlineBefore}
                                        inputProps={{ name: "deadlineBefore", type: "date" }}
                                        onChange={setFilter}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "userId" }}
                                    url={logistsList}
                                    placeholder="По ответственному"
                                    onChange={setFilter}
                                    propName="fullNameOrEmail"
                                    value={filters.userId}
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    onChange={setFilter}
                                    value={filters.groupId}
                                    placeholder="По группе пользователей"
                                    inputProps={{ name: "groupId" }}
                                    url={getListForSelect}
                                    propName="name"
                                />
                            </div>
                        </div>
                        <div className="b-filter__body-column">
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    onChange={setFilter}
                                    value={filters.type}
                                    placeholder="По типу"
                                    inputProps={{ name: "type" }}
                                    options={logistTaskTypes}
                                    unSearchable
                                />
                            </div>
                            <div className="pb-1">
                                <Select
                                    {...selectProps}
                                    inputProps={{ name: "carId" }}
                                    url={trucksList}
                                    placeholder="По машине"
                                    onChange={setFilter}
                                    propName="number"
                                    value={filters.carId}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="b-filter__footer pt-2">
                        {hasFilters && (
                            <div className="b-filter__btn b-filter__btn--reset" onClick={resetAllFilters}>
                                Сбросить
                            </div>
                        )}
                        <div className="b-filter__btn b-filter__btn--refresh" onClick={refreshData}>
                            Обновить
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
